import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { Contact } from './contact.model';
import { ContactFilters } from './contact.reducer';

export const ENTITY = 'contact';
export const SUBMIT = '[Contact] Submit';
export const REHYDRATE = '[Contact] Rehydrate';
export const REMOVE = '[Contact] Remove';
export const SET_FILTER = '[Contact] Set Filter';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Contact, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<Contact>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Contact, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: ContactFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.actions.ts